/**
 * @ngdoc service
 * @name smartSelectService
 * @module flowingly.components
 *
 * @description A service responsible solely for smart select component
 */

import { SharedAngular } from '@Angular.Runner/@types/sharedAngular';
import IGroupDetail from '@Shared.Angular/@types/core/contracts/queryModel/group/groupDetail';
import IUserDetailForModalResultModel from '@Shared.Angular/@types/core/contracts/queryModel/user/UserDetailForModalResultModel';
import { Guid } from '@Shared.Angular/@types/guid';
import { IHttpService } from 'angular';

angular
  .module('flowingly.components')
  .factory('smartSelectService', smartSelectService);

smartSelectService.$inject = ['$http', 'APP_CONFIG', 'flowinglyConstants'];

function smartSelectService(
  $http: IHttpService,
  APP_CONFIG: SharedAngular.APP_CONFIG,
  flowinglyConstants
) {
  let hasMoreResults = false;

  function getUsers(searchTerm: string, permissionSecureCodes: string[]) {
    return $http.get<IUserDetailForModalResultModel>(
      APP_CONFIG.apiBaseUrl +
        `users/search?maxNumberOfUsersToShow=${
          flowinglyConstants.maxNumberOfUsersToShow
        }${searchTerm ? '&searchTerm=' + searchTerm : ''}${
          permissionSecureCodes?.length > 0
            ? '&permissionSecureCodes=' + permissionSecureCodes
            : ''
        }`
    );
  }

  function getGroups() {
    return $http.get<IResponseData<IGroupDetail[]>>(
      APP_CONFIG.apiBaseUrl + 'teams?includeDetails=false'
    );
  }

  function getAvailableApprovers(
    nodeId: Guid,
    searchTerm?: string,
    noSpinner = false
  ) {
    return $http.get(
      `${
        APP_CONFIG.apiBaseUrl
      }flows/${nodeId}/availableStepApprovers?maxNumberOfUsersToShow=${
        flowinglyConstants.maxNumberOfUsersToShow
      }${searchTerm ? '&searchTerm=' + searchTerm : ''}`,
      { noSpinner }
    );
  }

  function getHasMoreResults() {
    return hasMoreResults;
  }

  function setHasMoreResults(val) {
    hasMoreResults = val;
  }
  const service = {
    getUsers: getUsers,
    getGroups: getGroups,
    getAvailableApprovers: getAvailableApprovers,
    getHasMoreResults: getHasMoreResults,
    setHasMoreResults: setHasMoreResults
  };

  return service;
}

export type SmartSelectServiceType = ReturnType<typeof smartSelectService>;
